document.addEventListener("DOMContentLoaded", () => {
  const cartDrawerContainer = document.getElementById("shopify-section-cart-drawer");

  // Function to handle "Add to Cart" click
  const handleAddToCartClick = () => {
    setTimeout(() => {
      sessionStorage.setItem("activateDrawer", "true");
      window.location.reload();
    }, 1200);
  };

  // Activate drawer after page reload with retry mechanism
  function callAfterAddtoCart() {
    if (sessionStorage.getItem("activateDrawer") === "true") {
      const activateDrawer = () => {
        const drawer = cartDrawerContainer?.querySelector(".drawer");
        if (drawer) {
          drawer.classList.add("active"); // Open drawer
          sessionStorage.removeItem("activateDrawer"); // Clean up flag
        } else {
          setTimeout(activateDrawer, 100); // Retry if drawer not found
        }
      };

      // Ensure this runs after full page load
      window.onload = activateDrawer;
    }
  }


  // Observe DOM changes to capture dynamically added buttons
  const observeAddToCartButtons = () => {
    const observer = new MutationObserver(() => {
      const addToCartButtons = document.querySelectorAll(".boost-sd__button[aria-label='Add to cart']");

      addToCartButtons.forEach((btn) => {
        if (!btn.dataset.listenerAdded) {
          btn.dataset.listenerAdded = "true";
          btn.addEventListener("click", handleAddToCartClick);
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };
  callAfterAddtoCart();
  observeAddToCartButtons();
});

